import * as actionTypes from "../actions/actionTypes";

const initState = {
  isInvoiceSubmitSuccess: false,
  isInvoiceSubmitFail: false,
  submitConfirmation: null,
  documentDetail: {},
  isProcessLoadDocumentDetail: false,
  isSubmissionCancelSuccess: false,
  isSubmissionCancelFail: false,
  isValidateTINSuccess: false,
  isValidateTINFail: false,
  isAddTaxpayerSuccess: false,
  isAddTaxpayerFail: false,
  isSetDefaultTaxpayerSuccess: false,
  isSetDefaultTaxpayerFail: false,
  taxSettings: [],
  isProcessLoadTaxSettings: false,
};

export default function EInvoiceReducer(state = initState, action) {
 
  switch (action.type) {
    
    case actionTypes.SUBMIT_INVOICE: {
      
      return {
        ...state,
        isInvoiceSubmitSuccess: false,
        isInvoiceSubmitFail: false,
        submitConfirmation: null,
      };
    }

    case actionTypes.SUBMIT_INVOICE_SUCCESS: {
    
      return {
        ...state,
        isInvoiceSubmitSuccess: (action.data && action.data.taxpayer_confirm) ? false : true,
        submitConfirmation: (action.data && action.data.taxpayer_confirm) ? action.data : null,
      };
    }

    case actionTypes.SUBMIT_INVOICE_FAIL: {
      return {
        ...state,
        isInvoiceSubmitFail: true
      };
    }

    case actionTypes.GET_TAX_DOCUMENT_DETAIL: {
      
      return {
        ...state,
        documentDetail: {},
        isProcessLoadDocumentDetail: true,
      };
    }

    case actionTypes.GET_TAX_DOCUMENT_DETAIL_SUCCESS: {
      return {
        ...state,
        documentDetail: action.data,
        isProcessLoadDocumentDetail: false,
      };
    }

    case actionTypes.GET_TAX_DOCUMENT_DETAIL_FAIL: {
      return {
        ...state,
        isProcessLoadDocumentDetail: false,
      };
    }


    case actionTypes.CANCEL_SUBMISSION: {
      return {
        ...state,
        isSubmissionCancelSuccess: false,
        isSubmissionCancelFail: false,
      };
    }

    case actionTypes.CANCEL_SUBMISSION_SUCCESS: {
      
      return {
        ...state,
        isSubmissionCancelSuccess: true
      };
    }

    case actionTypes.CANCEL_SUBMISSION_FAIL: {
      return {
        ...state,
        isSubmissionCancelFail: true
      };
    }


    case actionTypes.VALIDATE_TIN: {
      return {
        ...state,
        isValidateTINSuccess: false,
        isValidateTINFail: false,
      };
    }

    case actionTypes.VALIDATE_TIN_SUCCESS: {
      
      return {
        ...state,
        isValidateTINSuccess: true
      };
    }

    case actionTypes.VALIDATE_TIN_FAIL: {
      return {
        ...state,
        isValidateTINFail: true
      };
    }


    case actionTypes.ADD_TAXPAYER: {
      return {
        ...state,
        isAddTaxpayerSuccess: false,
        isAddTaxpayerFail: false,
      };
    }

    case actionTypes.ADD_TAXPAYER_SUCCESS: {
      
      return {
        ...state,
        isAddTaxpayerSuccess: true
      };
    }

    case actionTypes.ADD_TAXPAYER_FAIL: {
      return {
        ...state,
        isAddTaxpayerFail: true
      };
    }


    case actionTypes.SET_DEFAULT_TAXPAYER: {
      return {
        ...state,
        isSetDefaultTaxpayerSuccess: false,
        isSetDefaultTaxpayerFail: false,
      };
    }

    case actionTypes.SET_DEFAULT_TAXPAYER_SUCCESS: {
      
      return {
        ...state,
        isSetDefaultTaxpayerSuccess: true
      };
    }

    case actionTypes.SET_DEFAULT_TAXPAYER_FAIL: {
      return {
        ...state,
        isSetDefaultTaxpayerFail: true
      };
    }
    
    case actionTypes.LOAD_TAX_SETTINGS: {
      return {
        ...state,
        taxSettings: [],
        isProcessLoadTaxSettings: true,
      };
    }

    case actionTypes.LOAD_TAX_SETTINGS_SUCCESS: {
      
      return {
        ...state,
        taxSettings: action.data,
        isProcessLoadTaxSettings: false
      };
    }

    case actionTypes.LOAD_TAX_SETTINGS_FAIL: {
      return {
        ...state,
        isProcessLoadTaxSettings: false
      };
    }
    
    
    default:
      return state;
  }
}
